import React from "react";
import { useTranslation } from "react-i18next";
import TermsAndConditionsFr from "./TermsAndConditionsFR";
import TermsAndConditionsEn from "./TermsAndConditionsEN";

const TermsAndConditions = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <div className="container mx-auto px-4 py-8 text-onWhite">
      {lang === "fr" ? (
        <TermsAndConditionsFr />
      ) : lang === "en" ? (
        <TermsAndConditionsEn />
      ) : (
        <TermsAndConditionsEn />
      )}
    </div>
  );
};

export default TermsAndConditions;
